import React, { useState } from "react";
import styles from "../Footer_2/Footer_2.module.css";

// importing all social media images...
import facebook from "../../images/socialmedia_2/facebook.png";
import instagram from "../../images/socialmedia_2/instagram.png";
import linkedin from "../../images/socialmedia_2/linkedin.png";
import pintrest from "../../images/socialmedia_2/pintrest.png";
import twitter from "../../images/socialmedia_2/twitter.png";
import youtube from "../../images/socialmedia_2/youtube.png";
import Serving_Links from "../Serving_Links/Serving_Links";
import Available_Links from "../Available_Links/Available_Links";

const Footer = () => {
  // creating nav_links
  const nav_links = [
    "About Us",
    "Blog",
    "Near me",
    "Terms & Conditions",
    "Privacy Policy",
    "Contact Us",
  ];
  const social_links = [
    instagram,
    facebook,
    linkedin,
    twitter,
    pintrest,
    youtube,
  ];
  return (
    <div className={styles.container}>
      <h3 id={styles.top_heading}>Quick Links</h3>

      {/* ********Locations  and external links component */}
      <Serving_Links />

      {/* ******also avalaible Serving_Links and external links component */}
      <Available_Links />
      {/* bfooter component Contact Details... */}
      <div className={styles.contact}>
        <div className={styles.heading_2}> Contact Us</div>
        <div className={styles.footerLinks}>
          <div className={styles.mail_contact}>
            <a href="tel:7827621417"> Phone : +91 7827621417</a>
            <a href="mail:support@roservicecenter.live">
              {" "}
              Email :support@roservicecenter.live
            </a>
          </div>

          <div className={styles.Links}>
            {nav_links.map((elem, index) => {
              return (
                <>
                  <h3>{elem}</h3>
                </>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.social_link}>
        <div className={styles.links}>
          {/* mapping through all social_Links  */}
          {social_links.map((elem, index) => {
            return (
              <>
                <img src={elem} alt={index} />
              </>
            );
          })}
        </div>
        <h2>© 2022 House Cleaning Expert</h2>
      </div>
    </div>
  );
};

export default Footer;
